import { render, staticRenderFns } from "./ad-bid.vue?vue&type=template&id=8b425bf6&scoped=true"
import script from "./ad-bid.vue?vue&type=script&setup=true&lang=js"
export * from "./ad-bid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b425bf6",
  null
  
)

export default component.exports